import React from 'react';
import { Modal, Form, Input, Switch, Select, Button, message } from 'antd';
import { customBaseUrl, httpPost } from '../../store/http';
import { hideLoader, showLoader } from '../../utils/loader';
import Swal from 'sweetalert2';

const { Option } = Select;
const { TextArea } = Input;

const CreateProductModal = ({ showModal, hideModal, reloadProducts }) => {
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    showLoader();
    try {
      const payload = {
        ...values,
        status: values.status || 'ACTIVE', // Default to ACTIVE if not provided
        isActive: values.isActive !== undefined ? values.isActive : true, // Default to true
      };
      const response = await httpPost(`${customBaseUrl.integUrl}/api/v1/products`, payload);
      if (response.status) {
        message.success('Product created successfully');
        form.resetFields();
        hideModal();
        reloadProducts();
      } else {
        Swal.fire('Error', response.message || 'Failed to create product', 'error');
      }
    } catch (error) {
      console.error('Error creating product:', error);
      Swal.fire('Error', 'An error occurred while creating product', 'error');
    } finally {
      hideLoader();
    }
  };

  return (
    <Modal
      title="Create New Product"
      open={showModal}
      onCancel={hideModal}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ isActive: true, status: 'ACTIVE' }}
      >
        <Form.Item
          name="productName"
          label="Product Name"
          rules={[{ required: true, message: 'Please enter product name' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true, message: 'Please enter product description' }]}
        >
          <TextArea rows={4} />
        </Form.Item>
        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: 'Please select a status' }]}
        >
          <Select>
            <Option value="ACTIVE">ACTIVE</Option>
            <Option value="INACTIVE">INACTIVE</Option>
            <Option value="PENDING">PENDING</Option>
          </Select>
        </Form.Item>
        <Form.Item name="isActive" label="Is Active" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Create Product
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateProductModal;
